import { get, post } from "../utils/fetch";
import qs from 'query-string';
var FormUrlencoded = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
var FormDate = {
  'Content-Type': 'application/form-data'
};

// 通过projectId&collegeId获取公众号信息
export var querySourceInfo = function querySourceInfo(p) {
  return get('/luffy/internal/api/v1/wx/source', p, {
    visitor: true
  });
};

// 通过x_field获取公众号信息
export var querySourceInfoByFlag = function querySourceInfoByFlag(p) {
  return get('/luffy/internal/api/v1/wx/flag', p, {
    visitor: true
  });
};

// 通过shopid获取公众号信息
export var querySourceInfoByShopId = function querySourceInfoByShopId(p) {
  return get('/luffy/internal/api/v1/wx/shop', p, {
    visitor: true
  });
};

// 获取国家区号
export var queryCountrycodeList = function queryCountrycodeList(p) {
  return get('/notice/api/v1/countrycode', p, {
    visitor: true
  });
};

// 发送验证码
export var sendmessage = function sendmessage(p) {
  return post('/sso/v1/member/sendmessage', p, {
    visitor: true,
    headers: FormUrlencoded
  });
};

// 验证码获取服务推送
export var servicePushWhenSendSms = function servicePushWhenSendSms(p) {
  return post("/luffy/internal/api/v1/clue/send-sms", p, {
    visitor: true
  });
};

// 海外手机号验证码登录
export var LoginByOtherType = function LoginByOtherType(p) {
  return post('api/v1/type_login', p, {
    visitor: true,
    headers: FormDate
  });
};

// 获取企微开关状态
export var switchWxStatus = function switchWxStatus(p) {
  return get('/luffy/api/v1/wecom/switch/status', p);
};

// 登录并绑定公众号
export var loginAndBind = function loginAndBind(p) {
  return post('/api/v1/ucenter/loginAndBind', p, {
    visitor: true,
    headers: FormDate
  });
};

// 验证码登录
export var loginByCode = function loginByCode(p) {
  return post('/api/v1/ucenter/loginsms', p, {
    visitor: true,
    headers: FormUrlencoded
  });
};

// 获取活动详情
export var getActivityDetailByXfield = function getActivityDetailByXfield(x_field) {
  return get("/luffy/internal/api/v1/activity/detail-info/".concat(x_field), {}, {
    visitor: true
  });
};

// 获取活动详情
export var getActivityDetailById = function getActivityDetailById(id) {
  return get("/luffy/internal/api/v1/activity/detail/".concat(id), {}, {
    visitor: true
  });
};

// 查询模板详情
export var queryTemplateDetail = function queryTemplateDetail(p) {
  return get("/luffy/internal/api/template/config/detail", p, {
    visitor: true
  });
};

// 根据活动详情获取订单列表
export var queryOrderByActId = function queryOrderByActId(data) {
  return get('/luffy/internal/api/v1/order/activity/order/info', data);
};

/** 获取团购详情 type 为0传团购ID，为1传订单编号 */
export var quereGroupInfoByIdAndType = function quereGroupInfoByIdAndType(id, type) {
  return get("/luffy/internal/api/v1/groupon/".concat(id, "/").concat(type), {}, {
    visitor: true
  });
};

// 仅创建订单
export var createOrderOnly = function createOrderOnly(p) {
  return post('/luffy/internal/api/v1/order/only/create', p);
};

// 订单再支付
export var orderArousePayAgain = function orderArousePayAgain(p) {
  return post('/luffy/internal/api/v1/order/pay', p);
};

// 通过ordertoken获取订单信息
export var queryOrderDetailByOrderToken = function queryOrderDetailByOrderToken(p) {
  return get('/luffy/internal/api/v1/order/info_by_ordertoken', p);
};

// 获取对应问卷答案
export var queryAnswersByXfieldOrActId = function queryAnswersByXfieldOrActId(p) {
  return get("/luffy/internal/v1/api/marketing-activity/survey/answer", p);
};

// 提交问卷信息
export var answerQustions = function answerQustions(p) {
  return post("/luffy/internal/api/v1/survey/submit", p);
};

// 获取小程序跳转短链
export var getAppletUrlSchema = function getAppletUrlSchema(p) {
  return post("luffy/internal/api/v1/wechat/applet/scheme", p, {
    visitor: true
  });
};

// 获取店铺名称
export var getShopName = function getShopName(params) {
  return get("/luffy/api/v1/applet/list-by-name-like", params);
};

// 获取协议列表
export var getAgreementList = function getAgreementList(p) {
  return post('/luffy/v1/api/agreements/list', p, {
    visitor: true
  });
};

// 获取app列表
export var getAppList = function getAppList(p) {
  return get('/luffy/api/v1/wechat/lists', p);
};

// 获取app详情
export var getAppDetail = function getAppDetail(p) {
  return get('/luffy/internal/v1/app-version-update/getAppAddrByAppId', p, {
    visitor: true,
    noappid: true
  });
};

// 获取项目
export var getProjectList = function getProjectList(p) {
  return get('/vigo/web/v2/users/courseTypes', p);
};

// 获取小程序scheme url
export var getAppletScheme = function getAppletScheme(p) {
  return post('/luffy/internal/api/v1/wechat/applet/scheme', p, {
    visitor: true
  });
};

// 获取助教二维码
export var getAssistantQrcode = function getAssistantQrcode(p) {
  return get('/luffy/internal/api/v1/teaching_assistants/byUserIdAndProjectId', p);
};

// 获取优惠券列表
export var getCouponList = function getCouponList(p) {
  return get('/luffy/internal/api/v1/order/queryByDiscountId', p);
};

// 批量领取优惠券
export var batchReceiveCoupon = function batchReceiveCoupon(p) {
  return post('/luffy/internal/api/v1/coupon/batchReceiveCoupon', p);
};

// 判断是否领取过
export var isReceiveCoupon = function isReceiveCoupon(p) {
  return post('/luffy/internal/api/v1/coupon/batchAvailableReceiveCoupon', p);
};

// 发送验证码 - 滑块验证
export var sendMessageWithCaptcha = function sendMessageWithCaptcha(p) {
  return post('/passport/api/v1/captcha/send', p, {
    visitor: true
  });
};

// 发送验证码 - 对称加密
export var sendMessageWithSign = function sendMessageWithSign(p, extendArgs) {
  return post("/passport/api/v3/phone-code/send?".concat(qs.stringify(p)), undefined, {
    visitor: true,
    extendArgs: extendArgs
  });
};

// 推送行为
export var cluePush = function cluePush(params) {
  return post('/luffy/internal/api/v1/clue/push', params);
};

// 获取助教-单页面
export var getClueOwnerByProjectId = function getClueOwnerByProjectId(p) {
  return get('/luffy/internal/api/v1/allocation/getClueOwnerByProjectId', p);
};

// 根据wechatAppId获取app渠道列表
export var getAppChannelList = function getAppChannelList(p) {
  return get('/luffy/v1/api/app-version-update/queryAppChannelInfo', p);
};

// 根据wechatAppId和channel获取APKUrl
export var getApkUrl = function getApkUrl(p) {
  return get('/luffy/internal/v1/app-version-update/queryAppChannelInfo', p, {
    visitor: true
  });
};

// 根据项目获取分校城市列表
export var getSchoolCityList = function getSchoolCityList(p) {
  return get('/nami/api/v1/branch-school/campus/get-branch-city-list', p, {
    visitor: true
  });
};

// 根据项目和城市获取分校列表
export var getSchoolList = function getSchoolList(p) {
  return get('/nami/api/v1/branch-school/campus/get-branch-list', p, {
    visitor: true
  });
};